import { useSession } from "hooks/useSession";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
import FullscreenModal from "./components/FullScreenModal";
import RegisterKYCModalBody from "./components/RegisterBankKYCModalComponent";
import { RegisterKYCModalFooter } from "./components/ModalFooterKYC";
import useLocationService from "hooks/useLocationService";



import { method } from "lodash";
import { captureAvdm } from "utils/rdService";

function MainAEPSPage() {
  const {
    location,

    permission,
    getLocation,
    checkPermission,
  } = useLocationService(true);
  const navigate = useNavigate();
const [outletLoginModal, setOutletLoginModal] = useState(false);
const [outletLoginBank, setOutletLoginBank] = useState("");
const [outletPidData, setOutletPidData] = useState("");
const [outletLoginLoading, setOutletLoginLoading] = useState(false);
const [outletBankList, setOutletBankList] = useState([]);
  const { name, userid, role } = useSession();
  const [data, setData] = useState(null); // to store API data
  const [loading, setLoading] = useState(true); // to manage loader
  const [error, setError] = useState(null); // to handle errors
  
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [onboardingLoading, setOnboardingLoading] = useState(false);
const [showOtpModal, setShowOtpModal] = useState(false);
const [biometricKycModal, setBiometricKycModal] = useState(false);
const [biometricReferenceKey, setBiometricReferenceKey] = useState("");
const [biometricPidData, setBiometricPidData] = useState("");
const [biometricLoading, setBiometricLoading] = useState(false);
const [otp, setOtp] = useState("");
const [otpError, setOtpError] = useState("");

  const handleFormChange = (data) => setFormData(data);

  const handleStartOnboarding = async () => {
    if (onboardingLoading) return;
    setOnboardingLoading(true);
  
    try {
      await checkPermission();
      const loc = await getLocation(); // { lat, lng }
  
      const payload = new FormData();
      payload.append("userid", userid);
      payload.append("lat", loc?.lat ?? location?.lat);
      payload.append("long", loc?.lng ?? location?.lng);
  
      const res = await fetchWrapper("https://pro.mokshiq.in/merchant_onboarding_3", {
        method: "POST",
        body: payload,
      });
  
      if (res.status) {
        showMainToast("Onboarding completed successfully", "success");
        await handleCheckBiometricKyc();
        return;
      }
  
      // minKYC didn't go through directly — fall back to OTP-based signup
      await handleRequestOtp(loc);
    } catch (err) {
      showMainToast("Something went wrong while starting onboarding", "danger");
    } finally {
      setOnboardingLoading(false);
    }
  };


  const handleRequestOtp = async (loc) => {
    const payload = new FormData();
    payload.append("userid", userid);
    payload.append("lat", loc?.lat ?? location?.lat);
    payload.append("long", loc?.lng ?? location?.lng);
  
    const res = await fetchWrapper("https://pro.mokshiq.in/merchant_onboarding_otp_3", {
      method: "POST",
      body: payload,
    });
  
    if (res.status) {
      showMainToast("OTP sent to your registered mobile number", "success");
      setShowOtpModal(true);
    } else {
      showMainToast(res.data || "Unable to initiate onboarding", "danger");
    }
  };



  const handleVerifyOtp = async () => {
    if (!otp || otp.length < 4) {
      setOtpError("Enter a valid OTP");
      return;
    }
    setOnboardingLoading(true);
  
    try {
      const payload = new FormData();
      payload.append("userid", userid);
      payload.append("lat", location?.lat);
      payload.append("long", location?.lng);
      payload.append("otp", otp);
  
      const res = await fetchWrapper("https://pro.mokshiq.in/merchant_onboarding_verification_3", {
        method: "POST",
        body: payload,
      });
  
      // in handleVerifyOtp, on OTP verify success:
    if (res.status) {
      showMainToast("Onboarding completed successfully", "success");
      setShowOtpModal(false);
      setOtp("");
      await handleCheckBiometricKyc();
    } else {
        setOtpError(res.data || "Invalid OTP, please try again");
      }
    } catch (err) {
      setOtpError("Network error, please try again");
    } finally {
      setOnboardingLoading(false);
    }
  };

  const handleCheckBiometricKyc = async ({ fromActivationPending = false } = {}) => {
    try {
      const res = await fetchWrapper(
        `https://pro.mokshiq.in/biometric_kyc_status?userid=${userid}`,
        { method: "POST" }
      );
  
      if (res.status && res.data?.action === "ACTION-REQUIRED") {
        setBiometricReferenceKey(res.data.referenceKey);
        await checkPermission();
        await getLocation();
        setBiometricKycModal(true);
        return;
      }
  
      if (fromActivationPending) {
        // Biometric already done (or not required) — genuinely a bank-side wait
        showMainToast(
          "Your AePS activation is pending at the bank, please try again later.",
          "danger"
        );
        return;
      }
  
      // Called right after onboarding, nothing pending — continue the chain
      await handleCheckOutletStatus();
    } catch (err) {
      showMainToast("Unable to check biometric KYC status", "danger");
    }
  };
  
  const handleBiometricCapture = async () => {
    const response = await captureAvdm("MANTRA", "E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=");
    if (response.success) setBiometricPidData(response.data);
    else showMainToast("Fingerprint capture failed: " + response.error, "danger");
  };
  
  const handleSubmitBiometricKyc = async () => {
    if (!biometricPidData) return showMainToast("Please scan fingerprint first", "danger");
  
    setBiometricLoading(true);
    try {
      const payload = new FormData();
      payload.append("userid", userid);
      payload.append("referenceKey", biometricReferenceKey);
      payload.append("lat", location?.lat);
      payload.append("long", location?.lng);
      payload.append("xml_data", biometricPidData);
  
      const res = await fetchWrapper("https://pro.mokshiq.in/biometric_kyc", {
        method: "POST",
        body: payload,
      });
  
      if (res.status) {
        showMainToast("Biometric KYC completed successfully", "success");
        setBiometricKycModal(false);
        setBiometricPidData("");
        // proceed to bank KYC + outlet login check
        
      } else {
        showMainToast(res.data || "Biometric KYC failed", "danger");
      }
    } catch (err) {
      showMainToast("Network error during biometric KYC", "danger");
    } finally {
      setBiometricLoading(false);
    }
  };
  const handleSubmit = (data) => {
    console.log("Form submitted:", data);
    // TODO: Call your KYC register API here
  };
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetchWrapper(
        `https://pro.mokshiq.in/get_user_profile?user=${userid}`
      );

      setData(response.data);
    } catch (err) {
      showMainToast(err.message, 'danger');
    } finally {
      setLoading(false); // hide loader
    }
  };
  useEffect(() => {
    getLocation();

    fetchData();
  }, []);


  const closeModalAlways = () => {
    const modalEl = document.getElementById("modalAlwaysFullscreen");
    if (modalEl) {
      const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
      if (modalInstance) modalInstance.hide();
    }
  };


  const onboardingPS = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      // formData.append("userid", "3");
      const result = await fetchWrapper(
        `https://pro.mokshiq.in/aeps_onboarding?userid=${userid}`
      );

      if (result.status && result.data.onboard_pending === 0) {
        showMainToast(result.data.message, "success");
      } else if (result.status && result.data.hasOwnProperty("redirecturl") && result.data.redirecturl) {
        window.open(result.data.redirecturl, "_blank", "noopener,noreferrer");
      }

      else {
        setError(result.data.message);
      }
      // setData(result.data);
    } catch (err) {
      showMainToast(err.message, "danger");
    } finally {
      setLoading(false); // hide loader
    }

  }

  const handleCheckOutletStatus = async () => {
    try {
      const res = await fetchWrapper(
        `https://pro.mokshiq.in/outlet_login_status?userid=${userid}`,
        { method: "POST" }
      );
  
      if (res.status) {
        navigate("/instant_aeps_new");
        return;
      }
  
      if (
        typeof res.data === "string" &&
        res.data.toLowerCase().includes("activation is pending")
      ) {
        // Usually caused by incomplete biometric KYC — check that before telling user to wait
        await handleCheckBiometricKyc({ fromActivationPending: true });
        return;
      }
  
      await checkPermission();
      await getLocation();
      setOutletLoginModal(true);
    } catch (err) {
      showMainToast("Unable to check outlet login status", "danger");
    }
  };

  useEffect(() => {
  if (!outletLoginModal) return;
  const fetchBanks = async () => {
    try {
      const res = await fetchWrapper("https://pro.mokshiq.in/aeps_bank_list_1");
      if (res?.data) setOutletBankList(res.data);
    } catch (err) {}
  };
  fetchBanks();
}, [outletLoginModal]);

const handleOutletCapture = async () => {
  const response = await captureAvdm("MANTRA", "");
  if (response.success) setOutletPidData(response.data);
  else showMainToast("Fingerprint capture failed: " + response.error, "danger");
};

const handleOutletLogin = async () => {
  if (!outletLoginBank) return showMainToast("Please select a bank", "danger");
  if (!outletPidData) return showMainToast("Please scan fingerprint first", "danger");

  setOutletLoginLoading(true);
  try {
    const payload = new FormData();
    payload.append("user_id", userid);
    payload.append("type", "DAILY_LOGIN");
    payload.append("bankiin", outletLoginBank);
    payload.append("lat", location?.lat);
    payload.append("long", location?.lng);
    payload.append("xml_data", outletPidData);

    const res = await fetchWrapper("https://pro.mokshiq.in/aeps_outlet_login", {
      method: "POST",
      body: payload,
    });

    if (res.status) {
      showMainToast("Outlet login successful", "success");
      setOutletLoginModal(false);
      setOutletPidData("");
      navigate("/instant_aeps_new");
    } else {
      showMainToast(res.data || "Outlet login failed", "danger");
    }
  } catch (err) {
    showMainToast("Network error during outlet login", "danger");
  } finally {
    setOutletLoginLoading(false);
  }
};

  const checkSoftmintKYC = async () => { 
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("userid", userid);
      formData.append("platform", "WEB");
      const result = await fetchWrapper(
        `https://pro.mokshiq.in/soft_two_factor_status`,
        {
          method: "POST",
          body: formData
        }
      );

      if (!result.status) {
        showMainToast(result.data, "danger");
        window.open(result.new_data.data);
      } else if (result.status) {
       navigate("/aeps_service_2");
       showMainToast(result.data, "success");
      }

      else {
        setError(result.data.message);
      }
      // setData(result.data);
    } catch (err) {
      showMainToast(err.message, "danger");
    } finally {
      setLoading(false); // hide loader
    }
    }
  const updateMaplocation = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("userid", userid);
      formData.append("transection_platform", "WEB");
      formData.append("lat", location.lat);
      formData.append("long", location.lng);
      const result = await fetchWrapper(
        `https://pro.mokshiq.in/merchant_location_update`,
        {
          method: "POST",
          body: formData
        }
      );

      if (result.status) {
        showMainToast(result.message, "success");
        fetchData();
      }

      else {
        setError(result.message);
      }
      // setData(result.data);
    } catch (err) {
      showMainToast(err.message, "danger");
    } finally {
      setLoading(false); // hide loader
    }

  }

  return (
    <main>
      <div className="container-fluid ui-section">
        <div className="row m-1">
          <div className="col-12 ">
            <h4 className="main-title">AEPS Service</h4>
            <ul className="app-line-breadcrumbs mb-3">
              <li>
                <a className="f-s-14 f-w-500" href="#">
                  <span>
                    <i className="ph-duotone ph-briefcase-metal f-s-16"></i>{" "}
                    Services
                  </span>
                </a>
              </li>
              <li className="active">
                <a className="f-s-14 f-w-500" href="#">
                  AEPS
                </a>
              </li>
            </ul>
          </div>
        </div>

        {loading ? (
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="loader-container">
                    <div className="loader-main">
                      <div className="loader_box">
                        <div className="loader_16"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            {/* ✅ Three condition cases */}
            {data?.paeps_onboarding === true &&
              data?.paeps_reg_bank2 === true && data?.paeps_auth_bank2 === true ? (
              <div className="col-sm-12 col-md-12 col-xl-8">
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-xl-6">
                    {data?.gst_num === "123" ? (
                      <div className="card">
                        <div className="card-header">
                          <h5>Quick AEPS</h5>
                          <p className="mb-0 text-secondary">
                            Updte your shop lcation
                          </p>
                        </div>
                        <div className="card-body">
                          <button className="btn btn-primary btn-md" type="button" onClick={updateMaplocation}>
                            Update Map Location
                          </button>
                        </div>
                      </div>) : (<div className="card">
                        <div className="card-header">
                          <h5>Quick AEPS</h5>
                          <p className="mb-0 text-secondary">
                            Auth Bank KYC already completed ✅
                          </p>
                        </div>
                        <div className="card-body">
                          <button className="btn btn-primary btn-md" type="button" onClick={() => { window.location.href = "/aeps_service" }}>
                            Start Transection
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-xl-6">
                    <div className="card">
                      <div className="card-header">
                        <h5>Quick AadharPay</h5>
                        <p className="mb-0 text-secondary">
                          Auth Bank KYC already completed ✅
                        </p>
                      </div>
                      <div className="card-body">
                        <button className="btn btn-primary btn-md" type="button" onClick={() => { window.location.href = "/aadharpay_service" }}>
                          Start Aadhar Pay
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : data?.paeps_onboarding === true &&
              data?.paeps_reg_bank2 === true ? (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Quick AEPS</h5>
                    <p className="mb-0 text-secondary">
                      Please inititae with Auth KYC
                    </p>
                  </div>
                  <div className="card-body">
                    <button className="btn btn-warning btn-md" type="button" data-bs-toggle="modal"
                      data-bs-target="#modalAlwaysFullscreen">
                      Start Auth KYC
                    </button>
                  </div>
                </div>
              </div>
            ) : data?.paeps_onboarding === true &&
              data?.paeps_reg_bank2 === false ? (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Quick AEPS</h5>
                    <p className="mb-0 text-secondary">
                      Please inititate onboarding with bank.
                    </p>
                  </div>
                  <div className="card-body">
                    <button className="btn btn-warning btn-md" type="button" data-bs-toggle="modal"
                      data-bs-target="#modalAlwaysFullscreen">
                      Register Bank KYC
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Quick AEPS</h5>
                    <p className="mb-0 text-secondary">
                      Submit KYC – Aadhaar, PAN, and Bank details.
                    </p>
                  </div>
                  <div className="card-body">
                    <button
                      className="btn btn-light-primary btn-md"
                      type="button" onClick={onboardingPS}
                    >
                      Start Onboarding
                    </button>
                  </div>
                </div>
              </div>
            )}

{data?.outlet_id !== null && data?.outlet_id !== "" && data?.outlet_id !== undefined ? (
  <div className="col-sm-12 col-md-6 col-xl-4">
    <div className="card">
      <div className="card-header">
        <h5>Instant AEPS KYC</h5>
        <p className="mb-0 text-secondary">Check AEPS KYC.</p>
      </div>
      <div className="card-body">
        <button className="btn btn-light-primary btn-md" id="click_1" type="button" onClick={handleCheckOutletStatus}>
          Check KYC
        </button>
      </div>
    </div>
  </div>
) : (
  <div className="col-sm-12 col-md-6 col-xl-4">
    <div className="card">
      <div className="card-header">
        <h5>Instant AEPS</h5>
        <p className="mb-0 text-secondary">
          Submit KYC – Upload Aadhaar, PAN, and Bank details.
        </p>
      </div>
      <div className="card-body">
        <button
          className="btn btn-light-primary btn-md"
          id="click_1"
          type="button"
          onClick={handleStartOnboarding}
          disabled={onboardingLoading}
        >
          {onboardingLoading ? "Processing..." : "Start Onboarding"}
        </button>
      </div>
    </div>
  </div>
)}


{biometricKycModal && (
  <div className="modal show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Biometric KYC Required</h5>
          <button type="button" className="btn-close" onClick={() => setBiometricKycModal(false)} />
        </div>
        <div className="modal-body">
          <p className="text-secondary">
            Please complete biometric authentication to activate your outlet.
          </p>
          <div className="d-flex justify-content-center">
            <button
              onClick={handleBiometricCapture}
              className="btn btn-outline-primary p-0"
              style={{ width: "70px", height: "70px" }}
              type="button"
            >
              <img
                src="../assets/images/service/scan.gif"
                alt="Scan"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </button>
          </div>
          {biometricPidData && (
            <p className="text-success text-center mt-2 mb-0">Fingerprint captured</p>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setBiometricKycModal(false)}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmitBiometricKyc}
            disabled={biometricLoading}
          >
            {biometricLoading ? "Submitting..." : "Submit Biometric KYC"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{/* OTP Modal */}
{showOtpModal && (
  <div className="modal show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Verify OTP</h5>
          <button type="button" className="btn-close" onClick={() => setShowOtpModal(false)} />
        </div>
        <div className="modal-body">
          <label className="form-label">Enter the OTP sent to your registered mobile</label>
          <input
            className={`form-control ${otpError ? "is-invalid" : ""}`}
            type="text"
            maxLength="6"
            value={otp}
            onChange={(e) => {
              setOtp(e.target.value.replace(/\D/g, ""));
              setOtpError("");
            }}
          />
          {otpError && <div className="invalid-feedback">{otpError}</div>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setShowOtpModal(false)}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleVerifyOtp} disabled={onboardingLoading}>
            {onboardingLoading ? "Verifying..." : "Verify & Complete"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

            {/* E AEPS (always visible) */}
            <div className="col-sm-12 col-md-6 col-xl-4">
              <div className="card">
                <div className="card-header">
                  <h5>E AEPS</h5>
                  <p className="mb-0 text-secondary">
                    Submit KYC – Upload Aadhaar, PAN, and Bank details.
                  </p>
                </div>
                <div className="card-body">
                  <button
                    className="btn btn-light-primary btn-md"
                    id="click_1"
                    type="button"
                  >
                    Start Onboarding
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <FullscreenModal
        id="modalAlwaysFullscreen"
        title="Register KYC"
        BodyComponent={() => (
          <RegisterKYCModalBody onFormChange={handleFormChange} errors={errors} onSuccess={fetchData} />
        )}
        FooterComponent={() => (
          <RegisterKYCModalFooter
            onSubmit={handleSubmit}
            formData={formData}
            onSuccessClose={closeModalAlways}
          />

        )}

        size="lg"
      />
      {outletLoginModal && (
  <div className="modal show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Outlet Login Required</h5>
          <button type="button" className="btn-close" onClick={() => setOutletLoginModal(false)} />
        </div>
        <div className="modal-body">
          <label className="form-label">Select Bank</label>
          <select
            className="form-select mb-3"
            value={outletLoginBank}
            onChange={(e) => setOutletLoginBank(e.target.value)}
          >
            <option value="">Select Bank</option>
            {outletBankList.map((bank) => (
              <option key={bank.id} value={bank.iinno}>
                {bank.bankName}
              </option>
            ))}
          </select>

          <div className="d-flex justify-content-center">
            <button
              onClick={handleOutletCapture}
              className="btn btn-outline-primary p-0"
              style={{ width: "70px", height: "70px" }}
              type="button"
            >
              <img
                src="../assets/images/service/scan.gif"
                alt="Scan"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </button>
          </div>
          {outletPidData && <p className="text-success text-center mt-2 mb-0">Fingerprint captured</p>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setOutletLoginModal(false)}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleOutletLogin} disabled={outletLoginLoading}>
            {outletLoginLoading ? "Logging in..." : "Login Outlet"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </main>
  );

}

export default MainAEPSPage;
